import React, { useMemo, useEffect, useRef, useCallback } from 'react'
import t from '~t'
import { useDispatch, useSelector } from 'react-redux'
import { refresh } from '~data/actions/bookmarks'
import { makeSpaceElements, makeSelectMode, status as getStatus } from '~data/selectors/bookmarks'
import config from '~config'
import { target, openTab } from '~target'
import localStorage from '~modules/localStorage'

import { Modal, ModalHeader as Header, ModalContent as Content, Preloader } from '~ui'

const _warningKey = 'open-multiple-links-help-ignore'
let showWarning

export default function BookmarkOpenAll({ spaceId, selected = false, onClose }) {
    const dispatch = useDispatch()
    const getSpaceElements = useMemo(() => makeSpaceElements(), [])
    const getSelectMode = useMemo(() => makeSelectMode(), [])

    const bookmarks = useSelector(state => getSpaceElements(state, spaceId))
    const selectMode = useSelector(state => getSelectMode(state, spaceId))
    const status = useSelector(state => getStatus(state, spaceId))

    const open = useCallback(() => {
        const links = Object.entries(bookmarks)
            //only selected in selectMode
            .filter(([_, { _id }]) => {
                if (selected && !selectMode.all)
                    return selectMode.ids.includes(_id)

                return true
            })
            .map(([_, { link }]) => link)

        //open links
        openTab(links)

        //just close dialog when bookmarks less=1, or warning already showen
        if (links.length <= 1 || !showWarning)
            onClose()
        else {
            localStorage.setItem(_warningKey, 1)
            showWarning = false
        }
    }, [bookmarks, selectMode, selected, onClose])

    useEffect(() => {
        showWarning = target == 'web' && !localStorage.getItem(_warningKey)

        if (!selected && status.main != 'loaded')
            dispatch(refresh(spaceId))
        else
            open()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const prevMain = useRef(status.main)
    useEffect(() => {
        if (prevMain.current != status.main && status.main == 'loaded')
            open()
        prevMain.current = status.main
    }, [status.main, open])

    let body
    switch (status.main) {
        case 'loading':
            body = (
                <Header title={t.s('loading')}>
                    <Preloader />
                </Header>
            )
            break

        case 'empty':
            body = <Header title={t.s('noBookmarks')} />
            break

        case 'loaded':
            body = (
                <>
                    <Header title={t.s('havingProblems')} data-no-shadow />
                    <Content data-indent>
                        {t.s('openAllTabsHelp')} <a href={config.links.help['open-multiple-links']} target='_blank'>{t.s('learnMore')}</a>
                    </Content>
                </>
            )
            break

        default:
            body = <Header title={t.s('error')} />
            break
    }

    return (
        <Modal onClose={onClose}>
            {body}
        </Modal>
    )
}
